// tslint:disable
export var ProcessorType;
(function (ProcessorType) {
    // I2C
    ProcessorType[ProcessorType["I2C"] = 3] = "I2C";
    // Alegeus
    ProcessorType[ProcessorType["Alegeus"] = 9] = "Alegeus";
    // T-Chek
    ProcessorType[ProcessorType["TChek"] = 10] = "TChek";
})(ProcessorType || (ProcessorType = {}));
ProcessorType['ALEGEUS'] = 9;
ProcessorType['TCHEK'] = 10;
//# sourceMappingURL=ProcessorType.js.map